import { Constants } from '@src/types/constants'
import { Path, UseFormTrigger } from 'react-hook-form'
import { reportErrorToConsole } from './error-logger'

export const setYearMonthValueFromMonths = (
  months: number,
  yearSelect: HTMLSelectElement,
  monthSelect: HTMLSelectElement | null,
  useSelectForYearsOfResidenceAndEmployment: boolean,
) => {
  if (months) {
    yearSelect.value = ''
    const year = months === Constants.MaxMonthUnderOneYear ? -1 : Math.trunc(months / 12)

    yearSelect.value = year.toString()

    if (!useSelectForYearsOfResidenceAndEmployment && monthSelect) {
      monthSelect.value = ''
      const month = months % 12
      if (month > 0) monthSelect.value = month.toString()
      else monthSelect.selectedIndex = 0
    }
  }
}
export const calculateTotalMonths = (years: number, months: number, useSelect: boolean): number => {
  if (useSelect) {
    return years === -1 ? Constants.MaxMonthUnderOneYear : years * 12
  }
  return years * 12 + months
}
export const phoneFormat = (phone?: string | null) => {
  if (!phone) return ''
  const formatedInputVal = phone.replace(/\D/g, '')
  const size = formatedInputVal.length

  if (size > 6) {
    return `(${formatedInputVal.substring(0, 3)}) ${formatedInputVal.substring(3, 6)}-${formatedInputVal.substring(6, 10)}`
  } else if (size > 3) {
    return `(${formatedInputVal.substring(0, 3)}) ${formatedInputVal.substring(3)}`
  } else if (size > 0) {
    return `(${formatedInputVal}`
  }
  return ''
}

export const removePhoneFormat = (phoneFormated: string) => {
  let phone = phoneFormated.replace(' ', '')
  phone = phone.replace('(', '')
  phone = phone.replace(')', '')
  phone = phone.replace('-', '')

  return phone.substring(0, 10)
}

export const sinFormat = (sin: string) => {
  if (!sin) return sin
  let formatedInputVal = sin.replace(/\D/g, '')
  const size = formatedInputVal.length
  if (size > 3) {
    formatedInputVal = `${formatedInputVal.slice(0, 3)}-${formatedInputVal.slice(3)}`
  }
  if (size > 6) {
    formatedInputVal = `${formatedInputVal.slice(0, 7)}-${formatedInputVal.slice(7)}`
  }
  if (size > 9) {
    formatedInputVal = `${formatedInputVal.slice(0, 11)}`
  }
  return formatedInputVal
}

export const removeSinFormat = (sinFormated: string) => {
  return sinFormated.replace(/-/g, '')
}

export const getValuesFromObject = (keys: string[], values: Record<string, unknown>) => {
  const obj: Record<string, unknown> = {}
  keys.forEach((key) => {
    obj[key] = values[key]
  })
  return obj
}

export function validateObjectValue<T extends object>(object: T, trigger: UseFormTrigger<T>) {
  const validate = (field: string) => trigger(field as Path<T>)

  const validateChildObject = (parentKey: string, value: Record<string, unknown>) => {
    Object.entries(value).forEach(([childKey, childValue]) => {
      if (childValue) {
        if (typeof childValue !== 'object') validate(`${parentKey}.${childKey}`).catch(reportErrorToConsole)
        else if (typeof childValue === 'object')
          setTimeout(() => validateChildObject(`${parentKey}.${childKey}`, childValue as Record<string, unknown>), 0)
      }
    })
  }

  Object.entries(object).forEach(([key, value]) => {
    if (value) {
      if (typeof value !== 'object') validate(key).catch(reportErrorToConsole)
      else if (typeof value === 'object') validateChildObject(key, value as Record<string, unknown>)
    }
  })
}

// SIN Input
export const formatSIN = () => {
  const sin = document.querySelectorAll('.sin-input')

  function handleInput(this: HTMLInputElement) {
    this.value = sinFormat(this.value)
  }

  sin.forEach((elem) => {
    elem.addEventListener('input', handleInput)
  })
}

// Tooltip Adjustment
export const helpTip = () => {
  const helpTips = document.querySelectorAll('.help-tip')

  function handleMouseenter(this: HTMLInputElement) {
    const tooltip = this.querySelector('p')
    if (tooltip) {
      const tooltipWidth = tooltip.offsetWidth
      const tooltipOffset = this.getBoundingClientRect().left
      const viewportWidth = window.innerWidth

      if (tooltipOffset + tooltipWidth > viewportWidth) {
        tooltip.style.left = `${viewportWidth - tooltipOffset - tooltipWidth - 20}px`
        tooltip.classList.add('no-arrow') // Add a class to hide the arrow
      }
    }
  }

  function handleMouseleave(this: HTMLInputElement) {
    const tooltip = this.querySelector('p')
    if (tooltip) {
      tooltip.style.left = '-0.4rem'
      tooltip.classList.remove('no-arrow')
    }
  }

  helpTips.forEach((element) => {
    element.addEventListener('mouseenter', handleMouseenter)
    element.addEventListener('mouseleave', handleMouseleave)
  })
}

export const scrollToTop = () => {
  document.body.scrollTop = 0 // For Safari
  document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
}
export const replaceWithNonBreakingHyphen = (hyphenatedString: string) => {
  return hyphenatedString.replaceAll('-', '\u2011')
}

export const replaceLastSpaceWithNbsp = (str: string) => {
  return str.replace(/\s(?=\S*$)/, '\u00A0')
}
